function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

function updatedParseFloat(input) {
  const parsedInput = parseFloat(input)
  if (input === '' || isNaN(parsedInput)) {
    return null
  } else {
    return parsedInput
  }
}

function checkNumber(input) {
  if (input === 0) {
    return 0
  } else {
    return null
  }
}

function getEmailDomain(input) {
  const indexOfAt = input.indexOf('@')
  const inputAfterAt = input.slice(indexOfAt + 1)
  const indexOfPeriod = inputAfterAt.indexOf('.')
  const result = inputAfterAt.slice(0, indexOfPeriod)
  return result
}

function getQuoteTypeColors(quoteType) {
  switch (quoteType) {
    case 'frenchApfp':
      return '#B4F8C8'
    case 'frenchPostProd':
      return '#FBE7C6'
    case 'aicp':
      return '#A0E7E5'
    case 'photoGrid':
      return '#FFAEBC'
    default:
      return '#B4F8C8'
  }
}

export { delay, updatedParseFloat, checkNumber, getEmailDomain, getQuoteTypeColors }
